import { connect } from 'react-redux';
import {
    vendorInformation,
    vendorInformationLoad,
    vendorInformationRemove,
    createEventThunk,
    rejectEventThunk,
    approveEventThunk,
    requestInfoEventThunk,
    updateEventThunk,
    createAndSubmitEventThunk,
    updateAndSubmitEventThunk,
    resetEvent,
    setInvalidTabs,
    toggleEventRejectModal,
    toggleEventRequestModal,
    setEventUserAction,
    setEventErrorMessage,
    createAndStoreVendor,
    updateAndStoreVendor,
    createAndAssignVendor,
    updateAndAssignVendor,
    setPRModal,
    setPRComplete,
    setMCRCUploadedFile,
    updateAndApproveEventThunk,
    toggleEventApproveModal
} from '../../../actions';

import VendorInformation from '../../../components/event/vendor-information';

import {
    getJwtToken,
    getEventActions,
    getEventStatus
} from '../../../reducers';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state),
    vendorInformationData: state.event.vendorsInformation,
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasActions,
    contract: state.forms.event.contract,
    eventId: state.events.id,
    rejectModalActive: state.events.rejectModalActive,
    requestModalActive: state.events.requestModalActive,
    approveModalActive: state.events.approveModalActive,
    userAction: state.events.userAction,
    approvers: state.events.approvers,
    tasks: state.events.tasks,
    canSaveSubmit: state.events.eventSaveSubmit,
    canEdit: state.events.eventSaveSubmit,
    eventApproveReject: state.events.eventApproveReject,
    prComplete: state.events.prComplete,
    prModalActive: state.events.prModal,
    mcrcUploadedFile: state.events.mcrcUploadedFile,
    onsiteActivations: state.events.onsiteActivations,
    recommend: state.forms.event.recommend,
    recommendReason: state.forms.event.recommendReason,
    showVendorInfo: state.events.eventApproveReject
});

const mapDispatchToProps = dispatch => ({
    vendorInformation: object => dispatch(vendorInformation(object)),
    vendorInformationLoad: object => dispatch(vendorInformationLoad(object)),
    vendorInformationRemove: index => dispatch(vendorInformationRemove(index)),
    createEvent: (data, vendors) => dispatch(createEventThunk(data, vendors)),
    rejectEvent: data => dispatch(rejectEventThunk(data)),
    approveEvent: data => dispatch(approveEventThunk(data)),
    requestInfoEvent: data => dispatch(requestInfoEventThunk(data)),
    updateEvent: (data, vendors) => dispatch(updateEventThunk(data, vendors)),
    resetEvent: () => dispatch(resetEvent()),
    createAndSubmitEvent: (data, vendors) =>
        dispatch(createAndSubmitEventThunk(data, vendors)),
    updateAndSubmitEvent: (data, vendors) =>
        dispatch(updateAndSubmitEventThunk(data, vendors)),
    setInvalidTabs: e => dispatch(setInvalidTabs(e)),
    toggleRejectModal: () => dispatch(toggleEventRejectModal()),
    toggleRequestModal: () => dispatch(toggleEventRequestModal()),
    toggleApproveModal: () => dispatch(toggleEventApproveModal()),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: text => dispatch(setEventErrorMessage(text)),
    createAndStoreVendor: vendor => dispatch(createAndStoreVendor(vendor)),
    updateAndStoreVendor: vendor => dispatch(updateAndStoreVendor(vendor)),
    createAndAssignVendor: vendor => dispatch(createAndAssignVendor(vendor)),
    updateAndAssignVendor: vendor => dispatch(updateAndAssignVendor(vendor)),
    hidePRModal: () => dispatch(setPRModal(false)),
    showPRModal: () => dispatch(setPRModal(true)),
    setPRComplete: bool => dispatch(setPRComplete(bool)),
    setMCRCUploadedFile: bool => dispatch(setMCRCUploadedFile(bool)),
    updateAndApproveEvent: data => dispatch(updateAndApproveEventThunk(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorInformation);



// WEBPACK FOOTER //
// ./src/containers/event/vendor-information/index.js